import { useQuery } from '@tanstack/react-query';
import { apiServiceProxy } from 'v2/services/api-proxy';

export type CustomCreditDays = {
  has_custom_credit_days: boolean;
  days?: number;
};

export function useCustomCreditDays() {
  return useQuery({
    queryKey: ['anticipation', 'custom-credit-days'],
    queryFn: () =>
      apiServiceProxy.get<CustomCreditDays>('anticipation/custom-credit-days').then(response => response.data)
  });
}
